export enum MFAFlags
{
    None = 0,
    Email = 1,
    SMS = 2
}
